import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectEventsData, selectOfferType } from '../../onboarding/onboardingSlice';
import { selectPlan, setPlan } from '../paywallSlice';
import { selectUserInfo } from '../../login/loginSlice';
import { BestLabel, Description, StyledLi, StyledList, StyledOldValue, StyledPerWeek, StyledPeriod, StyledPrice, StyledValue, Title } from './styles/defaultStyles';
import { SelectedIcon, WhiteIcon } from './styles/icons';
import AppButton from './components/AppButton';
import AppTimer from './components/AppTimer';
import PlansDescription from './PlansDescription';

export const DiscountGzPlans = ({ onBuyClick }) => {
    const dispatch = useDispatch();
    const amplitudeEventData = useSelector(selectEventsData);
    const plan = useSelector(selectPlan);
    const landingType = useSelector(selectOfferType);
    const userInfo = useSelector(selectUserInfo);
    const displayedName = decodeURIComponent(userInfo?.name || amplitudeEventData?.user_email).split('@')[0];

    const discountPlans = useMemo(
        () => [
            {
                id: 'gz-1-month-intro7d-999-1999',
                title: '1',
                period: 'week trial',
                price: '$9.99*',
                label: 'Most popular',
            },
            {
                id: 'gz-1-month-1999',
                title: '1',
                period: 'month',
                price: '$19.99',
                oldPrice: '$29.99',
            },
            {
                id: 'gz-3-month-3999',
                title: '3',
                period: 'months',
                price: '$39.99',
                oldPrice: '$49.99',
            },
        ],
        []
    );
    const DISCOUNTS_PLANS = useMemo(
        () => ({
            gz_discount: discountPlans,
            'gz_discount-anim': discountPlans,
            'gz_new-discount': [
                {
                    id: 'gz-1-month-intro7d-499-1996',
                    title: '1',
                    period: 'week trial',
                    price: '$4.99*',
                    oldPrice: '$9.99',
                    label: 'special for you',
                },
                {
                    id: 'gz-1-month-1499',
                    title: '1',
                    period: 'month',
                    price: '$14.99',
                    oldPrice: '$29.99',
                },
                {
                    id: 'gz-3-month-2499',
                    title: '3',
                    period: 'months',
                    price: '$24.99',
                    oldPrice: '$49.99',
                },
            ],
        }),
        [discountPlans]
    );
  
    const currentPlans = useMemo(
        () => DISCOUNTS_PLANS[landingType],
        [landingType, DISCOUNTS_PLANS]
    );
  
    const discountPrices = useMemo(
        () => ({
            'gz-1-month-intro7d-999-1999': { price: '9.99', perMonth: '19.99' },
            'gz-1-month-intro7d-499-1996': { price: '4.99', perMonth: '19.96' },
        }),
        []
    );
  
    useEffect(() => {
        dispatch(setPlan(currentPlans[0].id));
    }, [dispatch, currentPlans]);
  
    const onPlanClick = (id) => dispatch(setPlan(id));

    const renderOffer = (i, index) => {
        const isActive = plan === i.id;
        return (
            <StyledLi
                active={isActive}
                onClick={() => onPlanClick(i.id)}
                key={i.id}
                id={`plan-button-${index + 1}`}
            >
                <StyledPeriod active={isActive}>
                    <div>{isActive ? SelectedIcon : WhiteIcon}</div>
                    <span>
                        {i.title} {i.period}
                    </span>
                </StyledPeriod>
                <StyledPrice active={i.label}>
                    {i.oldPrice && <StyledOldValue>{i.oldPrice}</StyledOldValue>}
                    <StyledValue>{i.price}</StyledValue>
                    <StyledPerWeek>{i.week}</StyledPerWeek>
                </StyledPrice>
                {i.label && <BestLabel isDiscount>{i.label}</BestLabel>}
            </StyledLi>
        );
    };
    const continueButton = (displayStickyBtn, sticky) => (
        <AppButton
            onClick={onBuyClick}
            bottomPosition={'24px'}
            displayStickyBtn={displayStickyBtn}
            position={sticky}
            customStickyWidth={'100%'}
            customBeforeHeight={'0px'}
            displayStubBtn={false}
        >
          Continue
        </AppButton>
    );

    return (
        <>
            <Title>
                <span>Hey</span>&nbsp;{displayedName}!
            </Title>
            <Description>Based on your answers, we’ve made the best program for your family’s safety!</Description>
            <AppTimer />
            <StyledList>{currentPlans.map(renderOffer)}</StyledList>
            {continueButton(true, 'sticky')}
            <PlansDescription continueButton={continueButton} showHint={
                plan.includes('intro7d') &&
                `*7-day ${discountPrices[plan].price} trial, then for ${discountPrices[plan].perMonth}/ month`
            }/>
        </>
    );
};

export default DiscountGzPlans;
